import { createReducer } from '@reduxjs/toolkit';
import { getFooterData } from '../actions/footerData';

const initialState = {
  loadingFooter: true,
  footerData: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getFooterData.fulfilled, (state, action) => ({
    ...state,
    footerData: action.payload,
    loadingFooter: false,
  }));
});
